import React, { useState, useEffect } from 'react';
import { collection, getDocs, doc, setDoc, deleteDoc } from 'firebase/firestore';
import { db } from '../firebase';
import { COLEGIOS as COLEGIOS_DEFAULT } from '../data/colegios';

export default function Colegios() {
  const [colegios, setColegios] = useState([]);
  const [loading, setLoading] = useState(true);
  const [form, setForm] = useState({ codigo:'', nombre:'' });
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');
  const [buscar, setBuscar] = useState('');
  const [confirmDelete, setConfirmDelete] = useState(null);
  const [editando, setEditando] = useState(null);

  async function cargar() {
    setLoading(true);
    try {
      const snap = await getDocs(collection(db,'colegios'));
      if (snap.empty) {
        const batch = COLEGIOS_DEFAULT.map(c => setDoc(doc(db,'colegios',c.codigo),{ codigo:c.codigo, nombre:c.nombre, activo:true, creadoEn:new Date().toISOString() }));
        await Promise.all(batch);
        setColegios(COLEGIOS_DEFAULT.map(c=>({id:c.codigo,...c,activo:true})));
      } else {
        setColegios(snap.docs.map(d=>({id:d.id,...d.data()})).sort((a,b)=>a.codigo.localeCompare(b.codigo)));
      }
    } catch(e) { setError('Error al cargar colegios: '+e.message); }
    setLoading(false);
  }
  useEffect(()=>{ cargar(); },[]);

  async function guardar(e) {
    e.preventDefault();
    if (!form.codigo.trim()||!form.nombre.trim()){setError('El código y el nombre son obligatorios.');return;}
    if (!/^\d{5}$/.test(form.codigo.trim())){setError('El código debe tener exactamente 5 dígitos.');return;}
    setSaving(true); setError(''); setSuccess('');
    try {
      await setDoc(doc(db,'colegios',form.codigo.trim()),{ codigo:form.codigo.trim(), nombre:form.nombre.trim().toUpperCase(), activo:true, creadoEn:new Date().toISOString() });
      setSuccess(editando?'Colegio actualizado.':'Colegio agregado correctamente.');
      setForm({codigo:'',nombre:''}); setEditando(null); cargar();
    } catch(e) { setError('Error al guardar: '+e.message); }
    setSaving(false);
  }

  async function eliminar(id) {
    try { await deleteDoc(doc(db,'colegios',id)); setColegios(p=>p.filter(c=>c.id!==id)); setConfirmDelete(null); }
    catch { alert('Error al eliminar.'); }
  }

  const filtrados = colegios.filter(c => c.nombre?.toLowerCase().includes(buscar.toLowerCase())||c.codigo?.includes(buscar));

  return (
    <div style={{ display:'grid', gridTemplateColumns:'340px 1fr', gap:20, alignItems:'start' }}>
      <div className="card">
        <div className="card-header" style={{ background:editando?'linear-gradient(90deg,rgba(181,122,0,.08),transparent)':'linear-gradient(90deg,rgba(0,45,98,.05),transparent)' }}>
          <h3>{editando?'✏️ Editar colegio':'+ Agregar colegio'}</h3>
          {editando&&<button className="btn btn-sm" onClick={()=>{setEditando(null);setForm({codigo:'',nombre:''});setError('');}}>Cancelar</button>}
        </div>
        <div className="card-body">
          {error&&<div style={{ background:'var(--red-light)',border:'1px solid #fca5a5',borderRadius:8,padding:'9px 12px',fontSize:13,color:'var(--red)',marginBottom:14 }}>{error}</div>}
          {success&&<div style={{ background:'#f0fdf4',border:'1px solid #86efac',borderRadius:8,padding:'9px 12px',fontSize:13,color:'#15803d',marginBottom:14,fontWeight:600 }}>✓ {success}</div>}
          <form onSubmit={guardar}>
            <div className="form-group">
              <label>Código SIGERD (5 dígitos)</label>
              <input value={form.codigo} onChange={e=>setForm(f=>({...f,codigo:e.target.value}))} placeholder="Ej: 07546" maxLength={5} disabled={!!editando} style={editando?{background:'#f3f4f6',color:'#9ca3af'}:{}}/>
            </div>
            <div className="form-group"><label>Nombre del colegio</label><input value={form.nombre} onChange={e=>setForm(f=>({...f,nombre:e.target.value}))} placeholder="NOMBRE DEL COLEGIO"/></div>
            <button type="submit" className="btn btn-primary" disabled={saving} style={{ width:'100%', justifyContent:'center' }}>{saving?'Guardando...':editando?'Actualizar colegio':'Agregar colegio'}</button>
          </form>
        </div>
      </div>
      <div className="card">
        <div className="card-header"><h3>Colegios del Distrito 1102 ({filtrados.length})</h3></div>
        <div style={{ padding:'10px 16px', borderBottom:'1px solid #f3f4f6' }}>
          <input type="text" placeholder="Buscar por nombre o código..." value={buscar} onChange={e=>setBuscar(e.target.value)} style={{ width:'100%', padding:'8px 12px', border:'1.5px solid #e5e7eb', borderRadius:8, fontSize:13, fontFamily:'inherit' }}/>
        </div>
        <div className="table-wrap">
          <table>
            <thead><tr><th>Código</th><th>Nombre</th><th>Acciones</th></tr></thead>
            <tbody>
              {loading?<tr><td colSpan={3} style={{ textAlign:'center',padding:28,color:'#9ca3af' }}>Cargando colegios...</td></tr>:
                filtrados.length===0?<tr><td colSpan={3} style={{ textAlign:'center',padding:28,color:'#9ca3af' }}>Sin resultados.</td></tr>:
                filtrados.map(c=>(
                  <tr key={c.id}>
                    <td><span style={{ background:'linear-gradient(135deg,#002D62,#0a3d80)',color:'#fff',fontSize:11,fontWeight:700,padding:'2px 9px',borderRadius:20 }}>{c.codigo}</span></td>
                    <td style={{ fontWeight:500, fontSize:13 }}>{c.nombre}</td>
                    <td>
                      <div style={{ display:'flex', gap:6 }}>
                        <button onClick={()=>{setEditando(c.id);setForm({codigo:c.codigo,nombre:c.nombre});setError('');setSuccess('');window.scrollTo(0,0);}} style={{ background:'#fffbeb',color:'#b45309',border:'1px solid #fde68a',borderRadius:6,padding:'4px 10px',fontSize:11,cursor:'pointer',fontFamily:'inherit',fontWeight:600 }}>Editar</button>
                        {confirmDelete===c.id?(
                          <div style={{ display:'flex', gap:5, alignItems:'center' }}>
                            <span style={{ fontSize:11, color:'#b91c1c' }}>¿Eliminar?</span>
                            <button onClick={()=>eliminar(c.id)} style={{ background:'#CE1126',color:'#fff',border:'none',borderRadius:5,padding:'3px 8px',fontSize:11,cursor:'pointer',fontFamily:'inherit',fontWeight:700 }}>Sí</button>
                            <button onClick={()=>setConfirmDelete(null)} style={{ background:'none',border:'1px solid #e5e7eb',borderRadius:5,padding:'3px 8px',fontSize:11,cursor:'pointer',fontFamily:'inherit' }}>No</button>
                          </div>
                        ):(
                          <button onClick={()=>setConfirmDelete(c.id)} style={{ background:'#fff0f0',color:'#CE1126',border:'1px solid #fca5a5',borderRadius:6,padding:'4px 10px',fontSize:11,cursor:'pointer',fontFamily:'inherit',fontWeight:600 }}>Eliminar</button>
                        )}
                      </div>
                    </td>
                  </tr>
                ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}
